import VideoJsAdapter from "./adapters/videojs_adapter";
import MSEAdapter from "./adapters/mse_adapter";
import VideoAdapter from "./adapters/video_adapter";
import DocumentAdapter from "./adapters/document_adapter";
import AdBlockDetector from "./utils/ad_block_detector";
import AhoyAdapter from "./adapters/ahoy_adapter";
import UserSession from './utils/user_session';
import { PlayerEnvironment } from "./player_environment";
import { Timing } from "./utils/timing";
import VideoHelpers from "./utils/video_helpers";

export default class PlayerFeedback {
  constructor(options = {}){
    this._data = options.data;
    this._tech = options.tech;
    this._uuid = options.uuid;
  }

  data(){
    return this._data;
  }

  tech(){
    return this._tech || {};
  }

  uuid(){
    return this._uuid;
  }

  sendUserFeedback() {
    this.redirectToSupport(this.supportUrl());
  }

  handlePlayerIssueFeedback() {
    if (UserSession.isLoggedIn()) {
      this.getPlayerIssueButton().click();
    } else {
      this.showLoginModal();
    }
  }

  getPlayerIssueButton() {
    const button_selector = this.data().isVideo() ? '.report-abuse-types__item--player-issue button' : '.b-livestreaming-report-issue-button';
    return document.querySelector(button_selector);
  }

  showLoginModal() {
    const data = this.getModalData();
    window.requireLoginModalClass.showModal(data);
  }

  getModalData() {
    const encodedPathName = encodeURIComponent(window.location.pathname);
    const locale = window.Locale[VideoHelpers.getLang()];
    const data = {
      title: locale.modal.require_login.title_report,
      url: `/users/login?user_return_to=${encodedPathName}`,
      locale: {
        require_login: {
          title: locale.modal.require_login.title,
          content: locale.modal.require_login.content
        }
      },
      embed: this.data().embed()
    };
    return data;
  }

  getFormData(token){
    var formData = new FormData();
    formData.append("property", JSON.stringify(this.getProperties()));
    formData.append("visitor_id", AhoyAdapter.global().visitorId);
    formData.append("authenticity_token", token);
    return formData;
  }

  redirectToSupport(url) {
    window.location.href = url;
  }

  getProperties(){
    var properties = {
      ad_blocker_enabled: AdBlockDetector.adBlockerEnabled(),
      advertisement_params: {},
      browser_name: PlayerEnvironment.browserName(),
      browser_version: PlayerEnvironment.browserVersion(),
      device_model: PlayerEnvironment.deviceModel(),
      device_vendor: PlayerEnvironment.deviceVendor(),
      drm: this.data().drmEnabled(),
      embed: this.data().embed(),
      flash_version: PlayerEnvironment.flashVersion(),
      geoblock_active: this.data().geoblock(),
      geoblock_url: this.data().geoblockUrl(),
      geoblocked: this.data().isGeoblocked(),
      os_name: PlayerEnvironment.osName(),
      os_version: PlayerEnvironment.osVersion(),
      platform: PlayerEnvironment.platform(),
      play_uuid: this.uuid(),
      player_name: "videojs",
      player_version: VideoJsAdapter.version(),
      ready_time: Timing.time(),
      referrer: DocumentAdapter.referrer(),
      support_h264: VideoAdapter.isSupportH264Encoding(),
      support_html5: VideoJsAdapter.isHtml5Supported(),
      support_mpeg_url: VideoJsAdapter.isMpegUrlSupported(),
      support_mse: MSEAdapter.isSupported(),
      support_mse_h264: VideoAdapter.isSupportMSEH264Encoding(),
      support_vp8: VideoAdapter.isSupportWebmVP8Encoding(),
      support_vp9: VideoAdapter.isSupportMSEVP9Encoding(),
      type: this.data().type(),
      video_id: this.data().videoId(),
      videopremier: this.data().isPremier()
    };

    if(this.tech().plugin() != undefined){
      var tech_properties = {
        buffered_video_frames: this.tech().bufferedVideoFrames(),
        corrupted_video_frames: this.tech().corruptedVideoFrames(),
        creation_time: this.tech().creationTime(),
        current_time: this.tech().currentTime(),
        dropped_video_frames: this.tech().droppedVideoFrames(),
        duration: this.tech().duration(),
        error_code: this.tech().errorCode(),
        is_fullscreen: this.tech().isFullscreen(),
        message: this.tech().errorMessage(),
        muted: this.tech().muted(),
        network_state: this.tech().networkState(),
        ready_state: this.tech().readyState(),
      };
      
      Object.assign(properties,tech_properties);
    }

    return properties;
  }

  supportUrl() {
    return "http://support.vidio.com/support/tickets/new";
  }
}
